module.exports = __webpack_public_path__ + "img/showcase-hotsheet-en-us.fb3d11e2.jpg";